import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";

const modalCss = `
  .ka-modal-dialog {
    width: calc(100% - 28px);
    max-width: 560px !important;
    margin-right: auto;
    margin-left: auto;
  }

  .ka-modal-dialog .modal-content,
  .ka-modal-content {
    overflow: hidden;
    border: 0 !important;
    border-radius: 16px !important;
    background: #ffffff;
    box-shadow: 0 20px 55px rgba(26, 34, 62, 0.24) !important;
  }

  .ka-modal-header {
    display: flex;
    min-height: 78px;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 18px 24px;
    border-bottom: 1px solid #e5eaf3;
    background: #ffffff;
  }

  .ka-modal-title {
    margin: 0;
    color: #14203b;
    font-size: 19px;
    font-weight: 700;
    line-height: 1.25;
  }

  .ka-modal-subtitle {
    margin: 4px 0 0;
    color: #7b88a8;
    font-size: 12px;
    line-height: 1.4;
  }

  .ka-modal-close {
    display: inline-flex;
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #26324f;
    font-size: 21px;
    line-height: 1;
    cursor: pointer;
  }

  .ka-modal-close:hover {
    background: #f3f5fb;
  }

  .ka-modal-body {
    max-height: calc(100vh - 240px);
    padding: 22px 24px 24px !important;
    overflow-y: auto;
    background: #ffffff;
  }

  .ka-student-card {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding: 13px 14px;
    border: 1px solid #e2e8f3;
    border-radius: 12px;
    background: #f8faff;
  }

  .ka-student-avatar {
    display: inline-flex;
    width: 38px;
    height: 38px;
    flex: 0 0 38px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #edf2ff;
    color: #4362e8;
    font-size: 14px;
    font-weight: 800;
  }

  .ka-student-label {
    margin-bottom: 2px;
    color: #7b87a3;
    font-size: 11.5px;
  }

  .ka-student-value {
    color: #17213d;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.4;
  }

  .ka-status-label {
    display: block;
    margin-bottom: 8px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .ka-status-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 20px;
  }

  .ka-status-option {
    display: inline-flex;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 10px;
    border: 1px solid #dfe5f0;
    border-radius: 10px;
    background: #ffffff;
    color: #59657c;
    font-size: 12.5px;
    font-weight: 700;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  }

  .ka-status-option:hover {
    border-color: #b7c5e3;
    background: #fafbff;
  }

  .ka-status-option.active {
    border-color: #7892ff;
    background: #f1f4ff;
    color: #4362e8;
    box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.06);
  }

  .ka-status-dot {
    width: 9px;
    height: 9px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    background: #aab3c3;
    box-shadow: 0 0 0 1px #c9d0dd;
  }

  .ka-status-option.active .ka-status-dot {
    background: #4362e8;
    box-shadow: 0 0 0 2px #c9d4ff;
  }

  .ka-form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 20px;
  }

  .ka-form-group {
    min-width: 0;
  }

  .ka-form-span-2 {
    grid-column: 1 / -1;
  }

  .ka-form-label {
    display: inline-block;
    margin-bottom: 7px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .ka-form-control {
    width: 100%;
    min-height: 43px;
    padding: 0 13px;
    border: 1px solid #dce3ef;
    border-radius: 10px;
    outline: none;
    background: #ffffff;
    color: #2f3a50;
    font-size: 13px;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  textarea.ka-form-control {
    min-height: 106px;
    padding-top: 11px;
    padding-bottom: 11px;
    resize: vertical;
  }

  .ka-form-control:focus {
    border-color: #7892ff;
    box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.08);
  }

  .ka-form-control:disabled {
    background: #f5f7fb;
    color: #9aa5b6;
    cursor: not-allowed;
  }

  .ka-modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 16px 24px 20px;
    border-top: 1px solid #e9edf4;
    background: #ffffff;
  }

  .ka-modal-btn {
    display: inline-flex;
    min-width: 98px;
    min-height: 40px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 16px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s ease, background 0.2s ease, border-color 0.2s ease;
  }

  .ka-modal-btn:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .ka-modal-btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .ka-modal-btn-secondary {
    border: 1px solid #dfe5f0;
    background: #ffffff;
    color: #64708d;
  }

  .ka-modal-btn-secondary:hover:not(:disabled) {
    border-color: #bec9dc;
    background: #f8faff;
  }

  .ka-modal-btn-primary {
    border: 1px solid #4362e8;
    background: #4362e8;
    color: #ffffff;
    box-shadow: 0 6px 15px rgba(67, 98, 232, 0.18);
  }

  .ka-modal-btn-primary:hover:not(:disabled) {
    border-color: #354fca;
    background: #354fca;
  }

  .ka-modal-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.45);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: kaModalSpin 0.7s linear infinite;
  }

  @keyframes kaModalSpin {
    to { transform: rotate(360deg); }
  }

  @media (max-width: 600px) {
    .ka-modal-header {
      min-height: 70px;
      padding: 16px 18px;
    }

    .ka-modal-title {
      font-size: 17px;
    }

    .ka-modal-body {
      padding: 18px !important;
    }

    .ka-status-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .ka-form-grid {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .ka-form-span-2 {
      grid-column: auto;
    }

    .ka-modal-footer {
      padding: 14px 18px 18px;
    }

    .ka-modal-btn {
      flex: 1;
    }
  }
`;

const formatDateLocal = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const normalizeTime = (time) => {
  if (!time) return "";
  return String(time).slice(0, 5);
};

const getTodayAttendance = (data) => {
  const today = formatDateLocal();

  return (
    data?.attendance_daily?.find((item) => item?.att_date === today) ||
    data?.attendance_daily?.find((item) => item?.att_daily?.att_date === today) ||
    null
  );
};

const getJamMasuk = (data) => {
  const todayAttendance = getTodayAttendance(data);

  return normalizeTime(
    todayAttendance?.att_daily?.in_time ||
      todayAttendance?.in_time ||
      data?.jam_masuk ||
      data?.in_time ||
      data?.check_in ||
      data?.time_in ||
      ""
  );
};

const getDefaultTypeKoreksi = (data) => {
  const todayAttendance = getTodayAttendance(data);
  const todayAttDaily = todayAttendance?.att_daily;

  if (todayAttDaily?.type_koreksi !== undefined && todayAttDaily?.type_koreksi !== null) {
    return Number(todayAttDaily.type_koreksi);
  }

  if (todayAttendance?.type_koreksi !== undefined && todayAttendance?.type_koreksi !== null) {
    return Number(todayAttendance.type_koreksi);
  }

  return getJamMasuk(data) ? 3 : 0;
};

const getStudentName = (data) =>
  data?.siswa || data?.nama_siswa || data?.name_student || "-";

const getInitials = (name) => {
  const words = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  return words.map((word) => word.charAt(0).toUpperCase()).join("") || "S";
};

const statusOptions = [
  { value: 3, label: "Hadir" },
  { value: 0, label: "Alpa" },
  { value: 1, label: "Sakit" },
  { value: 2, label: "Izin" },
];

export default function ModalDetailKoreksiAbsen({
  isOpen,
  toggle,
  selectedData,
  onSave,
  isSaving = false,
}) {
  const [form, setForm] = useState({
    tanggal: "",
    jam_masuk: "",
    catatan: "",
    type_koreksi: 0,
  });

  useEffect(() => {
    if (!isOpen) return;

    const today = formatDateLocal();
    const todayAttendance = getTodayAttendance(selectedData);
    const defaultType = getDefaultTypeKoreksi(selectedData);
    const jamMasuk = getJamMasuk(selectedData);

    setForm({
      tanggal: todayAttendance?.att_date || today,
      jam_masuk: defaultType === 3 ? jamMasuk : "",
      catatan:
        todayAttendance?.att_daily?.note ||
        todayAttendance?.note ||
        selectedData?.catatan ||
        selectedData?.note ||
        selectedData?.notes ||
        "",
      type_koreksi: defaultType,
    });
  }, [isOpen, selectedData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeTypeKoreksi = (type) => {
    setForm((prev) => ({
      ...prev,
      type_koreksi: type,
      jam_masuk: type === 3 ? prev.jam_masuk : "",
    }));
  };

  const handleSubmit = () => {
    if (typeof onSave === "function") {
      onSave({ ...form, selectedData });
    }
  };

  const studentName = getStudentName(selectedData);
  const isJamMasukDisabled = form.type_koreksi !== 3;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="ka-modal-dialog"
      contentClassName="ka-modal-content"
      backdrop={isSaving ? "static" : true}
      keyboard={!isSaving}
    >
      <style>{modalCss}</style>

      <div className="ka-modal-header">
        <div>
          <h5 className="ka-modal-title">Koreksi Absensi</h5>
          {/* <p className="ka-modal-subtitle">
            Perbarui status, tanggal, jam masuk, dan catatan absensi siswa.
          </p> */}
        </div>
        <button
          type="button"
          className="ka-modal-close"
          onClick={toggle}
          disabled={isSaving}
          aria-label="Tutup modal"
        >
          ×
        </button>
      </div>

      <ModalBody className="ka-modal-body mt-1">
        <div className="ka-student-card">
          <span className="ka-student-avatar">{getInitials(studentName)}</span>
          <div>
            <div className="ka-student-label">Nama Siswa</div>
            <div className="ka-student-value">{studentName}</div>
          </div>
        </div>

        <label className="ka-status-label">Status Absensi</label>
        <div className="ka-status-grid">
          {statusOptions.map((option) => (
            <button
              type="button"
              key={option.value}
              className={`ka-status-option ${form.type_koreksi === option.value ? "active" : ""}`}
              onClick={() => handleChangeTypeKoreksi(option.value)}
              disabled={isSaving}
            >
              <span className="ka-status-dot" />
              {option.label}
            </button>
          ))}
        </div>

        <div className="ka-form-grid">
          <div className="ka-form-group">
            <label className="ka-form-label" htmlFor="tanggalKoreksi">
              Tanggal
            </label>
            <input
              id="tanggalKoreksi"
              className="ka-form-control"
              type="date"
              name="tanggal"
              value={form.tanggal}
              onChange={handleChange}
              disabled={isSaving}
            />
          </div>

          <div className="ka-form-group">
            <label className="ka-form-label" htmlFor="jamMasukKoreksi">
              Jam Masuk
            </label>
            <input
              id="jamMasukKoreksi"
              className="ka-form-control"
              type="time"
              name="jam_masuk"
              value={form.jam_masuk}
              onChange={handleChange}
              disabled={isJamMasukDisabled || isSaving}
            />
          </div>

          <div className="ka-form-group ka-form-span-2">
            <label className="ka-form-label" htmlFor="catatanKoreksi">
              Catatan
            </label>
            <textarea
              id="catatanKoreksi"
              className="ka-form-control"
              name="catatan"
              value={form.catatan}
              onChange={handleChange}
              placeholder="Masukkan catatan koreksi absensi..."
              rows={4}
              disabled={isSaving}
            />
          </div>
        </div>
      </ModalBody>

      <div className="ka-modal-footer">
        <button
          type="button"
          className="ka-modal-btn ka-modal-btn-secondary"
          onClick={toggle}
          disabled={isSaving}
        >
          Batal
        </button>
        <button
          type="button"
          className="ka-modal-btn ka-modal-btn-primary"
          onClick={handleSubmit}
          disabled={isSaving}
        >
          {isSaving ? (
            <>
              <span className="ka-modal-spinner" />
              Menyimpan...
            </>
          ) : (
            "Simpan Perubahan"
          )}
        </button>
      </div>
    </Modal>
  );
}
